import React from "react";

export const Reload = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M19.96372,5.14025a.47588.47588,0,0,0-.26277-.25563L18.71757,4.493a.47983.47983,0,0,0-.6228.26777L16.68758,8.29742a.26356.26356,0,0,1-.30232.14991c-.0157-.00126-.03233-.00309-.04987-.006L12.911,6.94a.4795.4795,0,0,0-.631.24687l-.42456.96939a.48025.48025,0,0,0,.24737.631l5.14377,2.25528a.46538.46538,0,0,0,.61981-.25518l2.10243-5.281A.47974.47974,0,0,0,19.96372,5.14025Z" />
      <path d="M15.2886,15.03759l.01669-.05584L14.551,14.249a.45631.45631,0,0,0-.68807-.00894A5.66174,5.66174,0,0,1,8.40422,15.476c-.17744-.053-.35232-.11463-.52644-.18531A5.71816,5.71816,0,0,1,11.665,4.51379q.26211.07833.521.18369a5.727,5.727,0,0,1,3.55972,5.57046l-.00517.09608,1.92394.09232.00427-.09635a7.65491,7.65491,0,0,0-4.75717-7.44671q-.34637-.14106-.69771-.24583A7.64438,7.64438,0,0,0,7.15128,17.0746c.23.09377.46444.1761.70042.24664a7.64037,7.64037,0,0,0,7.35492-1.70081.44745.44745,0,0,0,.16206-.23365C15.415,15.23186,15.37772,15.06766,15.2886,15.03759Z" />
    </svg>
  );
};
